import React, { useState, useEffect, useRef } from 'react';
import { formatLongText } from '../../utils/utils';
import { formatPrice } from '@jbhi-fi/lanyard-ui/global/utils';
import ArrowDownSvg from '../../../../../../assets/svg/triangle-down.svg';
import { styles } from './Dropdown.css';

interface DropdownProps {
  name: string;
  variants: Array<{
    imageUrl: string;
    name: string;
    price: number;
    current: boolean;
    handle: string;
    sku: string;
  }>;
  switchProduct: (handle, name) => void;
}

const Dropdown = ({ name, variants, switchProduct }: DropdownProps): JSX.Element => {
  const dropdownRef = useRef(null);
  const formattedIdName = `dropdown-variants-${name.toLowerCase().replace(/\s/g, '-')}`;
  // handle metafields.online_product.value.Family.Options['Color'].Children not having the Value property set
  const currentText = variants?.find(variant => !!variant.current)
    ? variants?.find(variant => !!variant.current)[name]?.value
    : '';
  const currentPrice = variants?.find(variant => !!variant.current)
    ? variants?.find(variant => !!variant.current).price
    : undefined;
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    const checkIfClickOutsideDropdown = event => {
      if (dropdownRef && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActive(false);
      }
    };

    document.addEventListener('click', event => checkIfClickOutsideDropdown(event));

    return () => document.removeEventListener('click', event => checkIfClickOutsideDropdown(event));
  }, []);

  return (
    <div ref={dropdownRef} className={styles.variant} id={formattedIdName}>
      <div className={styles.title}>{name}</div>
      <div role="listbox" className={styles.dropdownContainer}>
        <div className={styles.input} onClick={() => setActive(!active)}>
          {formatLongText(currentText)} - <div className={styles.inputPrice}>${formatPrice(currentPrice)}</div>
          <div className={[styles.arrowDown, active ? 'active' : ''].join(' ')}>
            <ArrowDownSvg />
          </div>
        </div>
        <div className={[styles.dropdownContentContainer, active ? 'active' : ''].join(' ')}>
          {variants.map(variant => (
            <a
              key={`${variant.sku}-${variant.handle}`}
              href={`/products/${variant.handle}`}
              onClick={e => {
                e.preventDefault();
                switchProduct(variant?.handle, name);
                setActive(false);
              }}
              className={!!variant.current ? 'current' : ''}
            >
              {formatLongText(variant[name]?.value)} - <span>${formatPrice(variant?.price)}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
